import React from 'react';
import { X } from 'lucide-react';

export interface CloseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'small' | 'medium' | 'large';
}

export const CloseButton = ({
  size = 'medium',
  className = '',
  ...props
}: CloseButtonProps) => {
  const sizeClasses = {
    small: 'p-1.5',
    medium: 'p-2.5',
    large: 'p-3.5',
  };

  const iconSizes = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6',
  };

  return (
    <button
      className={`group relative text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-xl transition-all duration-200 hover:scale-110 active:scale-95 ${sizeClasses[size]} ${className}`}
      aria-label="Kapat"
      {...props}
    >
      <X className={`${iconSizes[size]} transition-transform group-hover:rotate-90`} />
      <span className="absolute inset-0 rounded-xl bg-gray-200/0 group-hover:bg-gray-200/50 transition-colors -z-10" />
    </button>
  );
};
